import PublicPage from './PublicPage';

const Announcements = () => {
  return <PublicPage pageType="announcements" backLink="/" />;
};

export default Announcements;
